import $ from 'jquery'
import Cookies from './../http/cookies'
import Request from './../http/request'

const Tracker = (($) => {

	class Tracker {
		constructor(){
			this._init()
		}

		_init(){
			this._checkForTrackingCode()
			this._checkForUTMCodes()
			this._checkForGoogleAdsClickID()
			this._checkForReferrer()
		}

		_checkForTrackingCode(){
			let tcid = Request.getQuery('tcid', false)

			if(tcid){
				Cookies.set('ion-tcid', tcid, 30)
			}
		}

		_checkForUTMCodes(){
			let utmID = Request.getQuery('utm_id', false)
			let utmSource = Request.getQuery('utm_source', false)
			let utmMedium = Request.getQuery('utm_medium', false)
			let utmCampaign = Request.getQuery('utm_campaign', false)
			let utmTerm = Request.getQuery('utm_term', false)
			let utmContent = Request.getQuery('utm_content', false)

			if(utmID){
				Cookies.set('utm-id', utmID, 30)
			}

			if(utmSource){
				Cookies.set('utm-source', utmSource, 30)
			}

			if(utmMedium){
				Cookies.set('utm-medium', utmMedium, 30)
			}

			if(utmCampaign){
				Cookies.set('utm-campaign', utmCampaign, 30)
			}

			if(utmTerm){
				Cookies.set('utm-term', utmTerm, 30)
			}

			if(utmContent){
				Cookies.set('utm-content', utmContent, 30)
			}
		}

		_checkForGoogleAdsClickID(){
			let gclid = Request.getQuery('gclid', false)

			if(gclid){
				Cookies.set('ion-gclid', gclid, 30)
			}
		}

		_checkForReferrer(){
			let referrer = document.referrer

			if( (!referrer) || (referrer == "") ){
				return
			}

			if(referrer.indexOf(document.location.origin) == 0){
				// Referrer is internal ignore
				return
			}

			let knownReferrer = Cookies.get('ion-referrer')

			if(knownReferrer != referrer){
				Cookies.set('ion-referrer', referrer, 30)
			}
		}

		getTrackingCode(){
			return Cookies.get('ion-tcid')
		}

		getUTMCodes(){
			return {
				utmID:Cookies.get('utm-id'),
				utmSource:Cookies.get('utm-source'),
				utmMedium:Cookies.get('utm-medium'),
				utmCampaign:Cookies.get('utm-campaign'),
				utmTerm:Cookies.get('utm-term'),
				utmContent:Cookies.get('utm-content'),
			}
		}

		getGoogleAdsClickID(){
			return Cookies.get('ion-gclid')
		}

		getReferrer(){
			return Cookies.get('ion-referrer')
		}
	}

	return new Tracker()
})($)

export default Tracker
